import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { FailedSolutions } from './components/FailedSolutions';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ResultsSection } from './components/ResultsSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
      window.fbq('init', '1235797295159430');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen w-full bg-warm-900 text-cream-100 overflow-x-hidden selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <FailedSolutions data-id="element-4" />
        <ProductReveal data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ForWhoSection data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ClosingSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-12">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1235797295159430&ev=PageView&noscript=1" alt="" data-id="element-13" />
      </noscript>
    </div>;
}